import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ImageLightboxData} from "../image-lightbox/image-lightbox.component";
import {FileService} from "../../services/file-service/file.service";
import {NotificationService} from "../../services/notification-service/notification.service";
import {PaymentService} from "../../api";
import {EditSubscriptionComponent} from "../edit-subscription/edit-subscription.component";
import {AuthService} from "@auth0/auth0-angular";

@Component({
  selector: 'app-cancel-subscription',
  templateUrl: './cancel-subscription.component.html',
  styleUrl: './cancel-subscription.component.scss'
})
export class CancelSubscriptionComponent {

  constructor(public dialogRef: MatDialogRef<CancelSubscriptionComponent>,
              @Inject(MAT_DIALOG_DATA) public data: string,
              protected paymentService: PaymentService,
              protected notificationService: NotificationService,
              protected authService: AuthService,
              ) {

  }


  onCancel(){
    this.paymentService.cancelEndpoint().subscribe(() => {
      this.notificationService.showSuccess("SUBSCRIPTION_CANCEL_SUBSCRIPTION");
      this.dialogRef.close();
      this.authService.logout({
        logoutParams: { returnTo: window.location.origin }
      })
    })
  }

}
